import React from 'react';
import { IPaymentOption } from 'src/components/store-payment/types';
import * as S from './styles';

const PaymentOptions: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPaymentOptionsProps>
>> = props => {
  return (
    <S.PaymentOptionList>
      {props.options.map(
        option =>
          option && (
            <S.PaymentOption active={Boolean(option.active)} key={option.name}>
              <S.CheckIcon size={22} />
              {option.translatedName}
            </S.PaymentOption>
          )
      )}
    </S.PaymentOptionList>
  );
};

export default PaymentOptions;

interface IPaymentOptionsProps {
  options: IPaymentOption[];
}
